import CancelTransactionPopup from './Finance/CancelTransactionPopup.vue'
import ImagePreviewModal from './ImagePreviewModal.vue'
import api from '../../api'
import taskStatuses from '../../helpers/taskStatuses'
import SideBar from '../../components/SideBar.vue'
import TaskDocuments from './TaskDocuments'
import datepicker from '../../components/datepicker.vue'
import timepicker from '../../components/timepicker.vue'
import modal from '../../components/modal.vue'
import roles from '../../helpers/userRoles'
import moment from 'moment'
import _ from 'lodash'
import { mapActions } from 'vuex'
import copy from 'copy-to-clipboard'
import vue2Dropzone from 'vue2-dropzone'

const getNewLocalStatus = currentStatusName => {
  let newStatus = {}
  switch (currentStatusName) {
    case 'unactive':
      newStatus = taskStatuses.find(x => x.name === 'active')
      break
    case 'active':
      newStatus = taskStatuses.find(x => x.name === 'finished')
      break
    case 'finished':
      newStatus = taskStatuses.find(x => x.name === 'unactive')
      break
    default:
      newStatus = taskStatuses.find(x => x.name === currentStatusName)
      break
  }

  return {
    id: newStatus.id,
    name: newStatus.name
  }
}

const getComment = (data, lastActivity, userId) => {
  return {
    isUserComment: data.user.id === userId,
    body: data.body,
    time:
      moment()
        .startOf('day')
        .diff(moment(data.created).startOf('day'), 'days') > 0
        ? moment(data.created).format('DD MMM HH:mm')
        : moment(data.created).format('HH:mm'),
    title: `${data.user.firstname} ${data.user.lastname}`,
    isNew: new Date(data.created) > new Date(lastActivity),
    id: data.created + data.body + new Date()
  }
}

const getHistoryMessageAction = (action, payload) => {
  switch (action) {
    case 'AcceptTask':
      return 'Принял(-а) задачу'
    case 'TaskCompleted':
      return 'Исполнил(-а) задачу'
    case 'DeclineTask':
      return 'Отклонил(-а) задачу'
    case 'SetedTask':
      return 'Поставил(-а) задачу'
    case 'PausedTask':
      return 'Отправил(-а) задачу на паузу'
    case 'FinishedTask':
      return 'Завершил(-а) задачу'
    case 'TaskOnStock':
      return 'Отправил(-а) задачу на склад'
    case 'TaskOnContract':
      return 'Отправил(-а) задачу на подряд'
    case 'TaskUpdated':
      return 'Обновил(-а) задачу'
    case 'TaskUpdatedPaid':
      return 'Изменил(-а) статус оплаты задачи'
    case 'TaskUpdatedDeadLine':
      return payload ? `Обновил(-а) дату сдачи задачи ${moment(payload.change.old).format('DD MMM YYYY HH:mm')} -> ${moment(payload.change.new).format('DD MMM YYYY HH:mm')}` : ''
    case 'AssignedTaskForDesigner':
      return 'Назначил(-а) задачу в отдел дизайна'
    case 'AssignedTaskForPrinter':
      return 'Назначил(-а) задачу в отдел печати'
    case 'AssignedTaskForAfter_printer':
      return 'Назначил(-а) задачу в отдел послепечати'
    case 'TaskCompletedDesigner':
      return 'Исполнил(-а) задачу отдела дизайна'
    case 'TaskCompletedPrinter':
      return 'Исполнил(-а) задачу отдела печати'
    case 'TaskCompletedAfter_printer':
      return 'Исполнил(-а) задачу отдела послепечати'
    case 'TaskUnactiveDesigner':
      return 'Отменил(-а) задачу в отделе дизайна'
    case 'TaskUnactivePrinter':
      return 'Отменил(-а) задачу в отделе печати'
    case 'TaskUnactiveAfter_printer':
      return 'Отменил(-а) задачу в отделе послепечати'
    case 'TaskUpdatedCost':
      return payload ? `Обновил(-а) cтоимость ${(+payload.change.old).toFixed(2)} -> ${(+payload.change.new).toFixed(2)}` : ''
    case 'TaskUpdatedTechMapDesc':
      return 'Изменил(-а) описание тех. карты'
    case 'TaskAddLayout':
      return `Добавил(-а) макет ${payload ? payload.info : ''}`
    case 'TaskUpdatedLayout':
      return `Обновил(-а) макет ${payload ? payload.info : ''}`
    case 'TaskDeleteLayout':
      return `Удалил(-а) макет ${payload ? payload.info : ''}`
    case 'AddFinanceInvoice':
      return 'Принял(-а) оплату'
    case 'CanceledFinanceInvoice':
      return 'Отменил(-а) оплату'
    case 'ApplyDiscountToTask':
      return payload ? `Применил(-а) скидку ${(+payload.change.old).toFixed(2)} -> ${(+payload.change.new).toFixed(2)}` : ''
    case 'ApplySurchargeToTask':
      return payload ? `Применил(-а) надбавку ${(+payload.change.old).toFixed(2)} -> ${(+payload.change.new).toFixed(2)}` : ''
    case 'OnAutoExecution':
      return 'Включил(-а) автоисполение'
    case 'OffAutoExecution':
      return 'Отключил(-а) автоисполение'
    case 'DocumentCreated':
      return `Создал(-а) документ ${payload.info.name} от ${payload.info.datetime} номером ${payload.info.number}`
    case 'DocumentSended':
      return `Отправил(-а) документ ${payload.info.name} на ${payload.info.sendTo}`
    case 'DocumentChanged':
      return `Изменил(-а) документ ${payload.info.name} от ${payload.info.datetime} номером ${payload.info.number}`
    case 'DocumentDeleted':
      return `Удалил(-а) документ ${payload.info.name} от ${payload.info.datetime} номером ${payload.info.number}`
    default:
      return ''
  }
}

const getHistoryMessage = data => {
  const msg = {
    userName: `${data.user.firstname} ${data.user.lastname} (${data.user.email})`,
    date: moment(data.datetime).format('DD MMMM'),
    time: moment(data.datetime).format('HH:mm'),
    action: getHistoryMessageAction(data.action, data.payload),
    id: data.datetime
  }
  return msg
}

const getPriceChangeTypes = () => {
  return [
    {
      id: 'discount',
      name: 'cкидку'
    },
    {
      id: 'premium',
      name: 'надбавку'
    }
  ]
}

const getNewInvoice = () => {
  return {
    price: '',
    financeAccount: '',
    date: moment().format('DD MMM YYYY'),
    description: ''
  }
}

export default {
  name: 'ViewTask',
  components: {
    datepicker,
    timepicker,
    SideBar,
    TaskDocuments,
    modal,
    vueDropzone: vue2Dropzone
  },
  props: {
    taskId: {
      default: null
    }
  },
  data: () => {
    return {
      userComment: '',
      roles: roles,
      statusesSections: {
        design: 'designer',
        print: 'printer',
        afterPrint: 'after_printer'
      },
      isActiveComments: true,
      isActiveHistory: false,
      isActiveLayouts: false,
      isActiveInfoMap: true,
      isActiveTechMap: false,
      isActiveFinance: false,
      isActiveDocuments: false,
      isAddLayout: false,
      taskTechMap: [],
      commentsData: [],
      historyData: [],
      layouts: [],
      newLayout: {
        link: '',
        description: ''
      },
      showPrintMenu: false,
      hideFinance: true,
      financeAccounts: [],
      invoices: [],
      invoice: getNewInvoice(),
      totalCost: 0,
      priceChangeTypes: getPriceChangeTypes(),
      priceChangeType: getPriceChangeTypes()[0].id,
      priceChangePercent: '',
      priceChangeAbsolute: '',
      previousRoute: null,
      dropzoneOptions: {
        url: '/api/file-manager/upload',
        thumbnailWidth: 75,
        thumbnailHeight: 75,
        maxFilesize: 512,
        timeout: 360000,
        addRemoveLinks: true,
        parallelUploads: 5
      },
      printWindow: null
    }
  },
  async beforeRouteEnter (to, from, next) {
    const resp = await api.get.task(to.params.taskId)

    next(vm => {
      vm.previousRoute = from
      vm.refreshLoadedTask(resp.data.data)
      vm.$eventBus.$emit('pageHeaderChange', 'Детали задачи')
    })
  },
  computed: {
    task () {
      const taskId = +this.taskId
      const task = this.$store.state.tasks.find(function (task) {
        return task.id === taskId
      }, this)
      if (!task) {
        return {}
      }
      const userCanViewTask = this.$store.getters.availiableTasks.some(
        x => x.id === taskId
      )
      !userCanViewTask && this.$router.push('/')
      const result = _.cloneDeep(task)
      result.isHot = result.status.name !== 'finished' && result.hot
      result.isOverdue =
        result.status.name !== 'finished' &&
        new Date(result.end_time) < new Date()
      result.autoAlert = !!result.auto_alert
      result.dedlineDate = moment(result.end_time).format('DD MMMM YYYY')
      result.dedlineTime = moment(result.end_time).format('HH:mm')
      result.creationDate = moment(result.start_time).format(
        'DD MMMM YYYY HH:mm'
      )
      result.designerUserName = result.designer.user && !this.isAdAgent
        ? `${result.designer.user.firstname} ${result.designer.user.lastname}`
        : '-'
      result.printerUserName = result.printer.user && !this.isAdAgent
        ? `${result.printer.user.firstname} ${result.printer.user.lastname}`
        : '-'
      result.afterPrinterUserName = result.after_printer.user && !this.isAdAgent
        ? `${result.after_printer.user.firstname} ${
        result.after_printer.user.lastname
        }`
        : '-'

      this.taskTechMap = task.tech_map ? task.tech_map.map(x => {
        return { ...x, expanded: false }
      }) : []

      result.techMapDesc = task.tech_map_desc
      result.autoExecution = task.auto_execution

      return result
    },
    comments () {
      return this.commentsData.slice().reverse()
    },
    historyMessages () {
      return this.historyData.slice().reverse()
    },
    showManagerActions () {
      switch (this.$store.getters.role) {
        case roles.director:
          return this.task.status.name !== 'finished'
        case roles.manager:
          return (
            this.task.manager.user.id === this.$store.state.userInfo.id &&
            this.task.status.name !== 'finished'
          )
        default:
          return false
      }
    },
    showCopyButton () {
      switch (this.$store.getters.role) {
        case roles.director:
        case roles.manager:
          return this.task.status.name === 'finished'
        default:
          return false
      }
    },
    showRestoreButton () {
      switch (this.$store.getters.role) {
        case roles.director:
          return this.task.status.name === 'finished'
        case roles.manager:
          return (
            this.task.manager.user.id === this.$store.state.userInfo.id &&
            this.task.status.name === 'finished'
          )
        default:
          return false
      }
    },
    showStaffActions () {
      if (
        this.task.status.name === 'finished' ||
        this.task.status.name === 'paused'
      ) {
        return false
      }
      switch (this.$store.getters.role) {
        case roles.designer:
          return this.isTaskForUserDesign()
        case roles.printer:
          return this.isTaskForUserPrint()
        case roles.afterPrinter:
          return this.isTaskForUserAfterPrint()
      }
      return false
    },
    showMasterActions () {
      if (
        this.task.status.name === 'finished' ||
        this.task.status.name === 'paused'
      ) {
        return false
      }

      if (this.$store.getters.role === roles.master) {
        return this.isTaskForUserDesign() || this.isTaskForUserPrint() || this.isTaskForUserAfterPrint()
      }

      return false
    },
    isAdAgent () {
      return this.$store.getters.role === roles.adAgent
    },
    isManageLayoutAvailiable () {
      if (this.showManagerActions) {
        return true
      }
      switch (this.$store.getters.role) {
        case roles.designer:
        case roles.master:
          return (this.task.designer.user && this.task.designer.user.id === this.$store.state.userInfo.id) &&
            this.task.designer.status.name === 'in progress'
        default:
          return false
      }
    },
    taskOnPause () {
      return this.task.status.name === 'stoped'
    },
    taskOnStore () {
      return this.task.status.name === 'on stock'
    },
    taskOnContract () {
      return this.task.status.name === 'contract'
    },
    isCanEditFinance () {
      return !this.hideFinance
    },
    taskDesignStatus () {
      return taskStatuses.find(x => x.id === this.task.designer.status.id)
    },
    taskPrintStatus () {
      return taskStatuses.find(x => x.id === this.task.printer.status.id)
    },
    taskAfterPrintStatus () {
      return taskStatuses.find(x => x.id === this.task.after_printer.status.id)
    },
    localTaskStatusForUser () {
      switch (this.$store.getters.role) {
        case roles.designer:
          return this.taskDesignStatus
        case roles.printer:
          return this.taskPrintStatus
        case roles.afterPrinter:
          return this.taskAfterPrintStatus
        default:
          return taskStatuses.find(x => x.name === 'unactive')
      }
    },
    priceChangeDelta () {
      if (this.totalCost < 0) {
        return 0
      }

      const priceChangeAbsolute = +(+this.priceChangeAbsolute.replace(',', '.')).toFixed(2)
      const priceChangePercent = +((+this.totalCost) * (+this.priceChangePercent.replace(',', '.')) / 100).toFixed(2)

      return +(priceChangeAbsolute + priceChangePercent).toFixed(2)
    },
    resultCost () {
      const payedCost = +this.invoices.reduce((accumulator, currentValue) => accumulator + (currentValue.canceled ? 0 : currentValue.price), 0)
      if (this.priceChangeType === 'discount') {
        return (+this.totalCost - this.priceChangeDelta - payedCost).toFixed(2)
      }
      return (+this.totalCost + this.priceChangeDelta - payedCost).toFixed(2)
    },
    isHistoryVisible () {
      return this.showManagerActions || this.showRestoreButton
    },
    isDocumentsVisible () {
      return this.showManagerActions || this.showRestoreButton
    }
  },
  methods: {
    returnBack () {
      if (this.previousRoute.path.indexOf('/tasks') === 0 || this.previousRoute.path.indexOf('/ad-agent/tasks') === 0) {
        this.$router.push(this.previousRoute.path)
      } else {
        this.$router.push('/')
      }
    },
    isTaskForUserAfterPrint () {
      return ((!this.task.after_printer.user ||
        this.task.after_printer.user.id ===
        this.$store.state.userInfo.id) &&
        (this.task.after_printer.status.name === 'active' ||
          this.task.after_printer.status.name === 'in progress'))
    },
    isTaskForUserPrint () {
      return ((!this.task.printer.user ||
        this.task.printer.user.id === this.$store.state.userInfo.id) &&
        (this.task.printer.status.name === 'active' ||
          this.task.printer.status.name === 'in progress'))
    },
    isTaskForUserDesign () {
      return ((!this.task.designer.user ||
        this.task.designer.user.id === this.$store.state.userInfo.id) &&
        (this.task.designer.status.name === 'active' ||
          this.task.designer.status.name === 'in progress'))
    },
    refreshLoadedTask ({ task }) {
      this.$store.commit('UPDATE_TASK_BY_ID', { task })
    },
    loadComments () {
      const userId = this.$store.state.userInfo.id
      api.get.getCommentsReadDate(this.taskId).then(resp => {
        const lastActivity = resp.data.data.last_activity
        api.get.loadComments(this.taskId).then(resp => {
          this.commentsData = resp.data.data.comments.map(x =>
            getComment(x, lastActivity, userId)
          )
          api.post.updateCommentsReadDate(this.task.id)
        })
      })
    },
    sendComment () {
      const comment = this.userComment
      if (!this.userComment || comment.trim().length === 0) {
        return
      }
      api.post.sendComments(this.taskId, this.userComment).then(() => {
        this.loadComments()
      })
      this.userComment = ''
    },
    loadHistory () {
      api.get.getTaskHistory(this.taskId).then(resp => {
        this.historyData = resp.data.data.activities.map(x =>
          getHistoryMessage(x)
        )
      })
    },
    editTask () {
      this.$router.push(`/update-task/${this.taskId}`)
    },
    hidePrintMenu () {
      const self = this
      setTimeout(function () {
        self.showPrintMenu = false
      }, 200)
    },
    printTaskClient () {
      this.printWindow && this.printWindow.close()
      this.printWindow = window.open(`/api/tasks/${this.task.id}/tm-for-client`, 'Печать задачи', 'width=600,height=600')
      const printWindow = this.printWindow
      printWindow.addEventListener('load', function () {
        setTimeout(function () { printWindow.print() }, 500)
      })
      this.showPrintMenu = false
    },
    printTaskTechMap () {
      this.printWindow && this.printWindow.close()
      this.printWindow = window.open(`/api/tasks/${this.task.id}/tm-for-prod`, 'Печать задачи', 'width=600,height=600')
      const printWindow = this.printWindow
      printWindow.addEventListener('load', function () {
        setTimeout(function () { printWindow.print() }, 500)
      })
      this.showPrintMenu = false
    },
    pauseTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'stoped').id
      )
    },
    sendToStoreTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'on stock').id
      )
    },
    async sendEmailToClient () {
      try {
        await api.get.sendEmailToClient(this.taskId)
        this.$notify({
          message: 'Оповещение отправлено',
          type: 'success'
        })
      } catch (ex) {
        // ignore
      }
    },
    sendToContractTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'contract').id
      )
    },
    closeTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'finished').id
      ).then(() => {
        this.returnBack()
      })
    },
    restoreTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'active').id
      )
    },
    copyTask () {
      this.$router.push(`/copy-task/${this.taskId}`)
    },
    unpauseTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'active').id
      )
    },
    returnFromStoreTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'active').id
      )
    },
    returnFromContractTask () {
      api.post.updateTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'active').id
      )
    },
    acceptTask (role) {
      api.post.updateLocalTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'in progress').id,
        role
      )
    },
    disclaimTask (role) {
      api.post.updateLocalTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'active').id,
        role
      )
    },
    resolveTask (role) {
      api.post.updateLocalTaskStatus(
        this.taskId,
        taskStatuses.find(x => x.name === 'finished').id,
        role
      )
    },
    changeLocalStatus (statusesSection, currentStatus) {
      if (this.task.status.name === 'finished') return
      const userId = this.$store.state.userInfo.id
      const newStatus = getNewLocalStatus(currentStatus.name)
      if (newStatus.id === currentStatus.id) {
        return
      }

      if (this.task.autoExecution && (newStatus.name === 'active' || newStatus.name === 'unactive')) {
        return
      }

      const updateTaskStaff = {}
      if (newStatus.name === 'active' || newStatus.name === 'unactive') {
        updateTaskStaff[statusesSection] = null
      }
      if (newStatus.name === 'finished') {
        updateTaskStaff[statusesSection] = userId
      }

      let updateStatus = {
        statuses: {
          [statusesSection]: newStatus.id
        }
      }
      updateStatus = { ...updateStatus, ...updateTaskStaff }
      api.post.updateTask(this.task.id, updateStatus).then(() => {
        this.refreshTask(this.task.id)
      })
    },
    toggeleComments () {
      this.isActiveComments = true
      this.isActiveHistory = false
      this.isActiveLayouts = false
      this.isActiveFinance = false
      this.isActiveDocuments = false
    },
    toggeleHistory () {
      this.isActiveComments = false
      this.isActiveHistory = true
      this.isActiveLayouts = false
      this.isActiveFinance = false
      this.isActiveDocuments = false
    },
    toggeleLayouts () {
      this.isActiveComments = false
      this.isActiveHistory = false
      this.isActiveLayouts = true
      this.isActiveFinance = false
      this.isActiveDocuments = false
    },
    toggeleFinance () {
      this.isActiveComments = false
      this.isActiveHistory = false
      this.isActiveLayouts = false
      this.isActiveFinance = true
      this.isActiveDocuments = false
    },
    toggeleDocuments () {
      this.isActiveComments = false
      this.isActiveHistory = false
      this.isActiveLayouts = false
      this.isActiveFinance = false
      this.isActiveDocuments = true
    },
    toggeleInfoMap () {
      this.isActiveInfoMap = true
      this.isActiveTechMap = false
    },
    toggeleTechMap () {
      this.isActiveInfoMap = false
      this.isActiveTechMap = true
    },
    toggleShowPrintMenu () {
      this.showPrintMenu = !this.showPrintMenu
    },
    sendingLayoutEvent (file, xhr, formData) {
      formData.append('tid', this.taskId)
      formData.append('size', file.size)
    },
    onLayoutUploadComplete (file) {
      if (file.status === 'error') {
        this.$notify({
          message: `Файл ${file.name} не загружен`,
          type: 'danger'
        })

        this.$refs.myVueDropzone.removeFile(file)
      }

      if (file.status === 'success') {
        this.$notify({
          message: `Файл ${file.name} загружен`,
          type: 'success'
        })

        this.$refs.myVueDropzone.removeFile(file)
        this.loadLayouts()
      }
    },
    addLayout () {
      this.isAddLayout = true
    },
    loadLayouts () {
      api.get.getTaskLayouts(this.taskId)
        .then(resp => {
          this.layouts = resp.data.data.layouts.map(x => { return { ...x, isInEdit: false, updateTime: moment(x.mtime).format('DD.MM.YYYY HH:mm') } }).reverse()
        })
        .catch(() => {
          this.layouts = []
        })
    },
    cancelAddLayout () {
      this.isAddLayout = false
      this.newLayout = {
        link: '',
        description: ''
      }
    },
    saveNewLayout () {
      if (this.newLayout.link) {
        api.post.addTaskLayout(this.taskId, this.newLayout).then(() => {
          this.loadLayouts()
        })
      }
      this.cancelAddLayout()
    },
    deleteLayout (id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.get.deleteTaskLayout(this.taskId, id).then(() => {
                this.loadLayouts()
              })
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    copyLayoutLink (item) {
      copy(item.link)
    },
    editLayout (item) {
      item.isInEdit = true
    },
    saveEditedLayout (item) {
      if (item.link || item.file) {
        api.post.updateTaskLayout(this.taskId, item.id, { description: item.description, link: item.link })
          .then(() => {
            this.loadLayouts()
          })
          .catch(() => {
            this.loadLayouts()
          })
      }
    },
    cancelEditLayout (item) {
      item.isInEdit = false
      this.loadLayouts()
    },
    loadTaskInvoices () {
      api.get.taskInvoices(this.taskId).then((resp) => {
        if (resp.data.data.finance_invoices.length > 0) {
          this.totalCost = (+resp.data.data.finance_invoices[0].totalCost).toFixed(2)
          this.invoices = resp.data.data.finance_invoices.filter(x => !!x.parentInvoice).sort((x, y) => x.id - y.id).reverse().map(x => {
            return {
              id: x.id,
              price: +x.price,
              financeAccountName: x.financeAccountName,
              date: moment(x.paymentTime).format('DD MMM YYYY HH:mm'),
              description: x.description,
              canceled: x.canceled
            }
          })
          this.hideFinance = !(this.showManagerActions || this.showRestoreButton)
        } else {
          this.hideFinance = true
          this.totalCost = (+this.task.price).toFixed(2)
        }
      })
    },
    loadFinanceAccounts () {
      api.get.financeAccounts().then((resp) => {
        this.financeAccounts = resp.data.data.finance_accounts
          .filter(x => x.enabled)
          .map(x => {
            return {
              id: x.id,
              name: x.name
            }
          })
      })
    },
    applyDiscount () {
      const discount = this.priceChangeDelta * (this.priceChangeType === 'discount' ? -1 : 1)
      api.post.applyFinanceDiscount(this.taskId, discount).then(() => {
        this.loadTaskInvoices()
        this.priceChangePercent = ''
        this.priceChangeAbsolute = ''
      })
    },
    updateInvoicePrice (price) {
      this.invoice.price = price.replace(',', '.')
    },
    addInvoice () {
      const invoice = {
        price: this.invoice.price,
        faid: this.invoice.financeAccount,
        tid: this.taskId,
        description: this.invoice.description
      }
      api.post.addInvoice(invoice).then(() => {
        this.loadTaskInvoices()
        this.invoice = getNewInvoice()
      })
    },
    cancelInvoice (invoice, reason) {
      api.post.cancelInvoice(invoice.id, !invoice.canceled, reason).then(() => {
        this.loadTaskInvoices()
      })
    },
    showCancelInvoicePopup (invoice) {
      const cancelTransactionAction = (reason) => this.cancelInvoice(invoice, reason)
      this.$modal.show(CancelTransactionPopup, {
        cancelTransaction: cancelTransactionAction
      }, {
        height: 'auto'
      })
    },
    previeImageFile (imgSrc, name) {
      const modalProps = {
        imgSrc,
        name
      }
      this.$modal.show(ImagePreviewModal, {
        ...modalProps
      }, {
        height: 'auto',
        width: 800,
        reset: true
      })
    },
    ...mapActions({
      refreshTask: 'UPDATE_TASK'
    })
  },
  created () {
    if (!this.isAdAgent) {
      this.loadComments()
      this.loadHistory()
      this.loadLayouts()
      this.loadFinanceAccounts()
      this.loadTaskInvoices()
    } else {
      this.toggeleLayouts()
      this.loadLayouts()
      this.loadTaskInvoices()
    }
  },
  mounted () {
    if (this.isAdAgent) return
    const customerId = this.$store.state.userInfo.customer.id
    const self = this
    this.$store.state.webSocket.on('socket/connect', function (session) {
      session.subscribe(`api/ws/activity/customer/${customerId}`, function (
        uri,
        payload
      ) {
        const parsedPayload = JSON.parse(payload)
        if (parsedPayload.comment) {
          if (parsedPayload.task.id === self.task.id) {
            self.loadComments(parsedPayload.task.id)
          }
        }
        if (parsedPayload.stream === 'task') {
          if (parsedPayload.event.id === self.task.id) {
            self.loadHistory()
          }
        }
      })
    })
  }
}
